"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cookieStorage = exports.CookieStorage = void 0;
const core_1 = require("../core");
const cookies_1 = require("./cookies/cookies");
/**
 * Class for managing cookie storage with a similar interface to the Web Storage API.
 */
class CookieStorage {
    /**
     * Creates an instance of CookieStorage.
     *
     * @param cookiesStorageParams - Optional parameters for configuring cookie storage.
     */
    constructor(cookiesStorageParams) {
        this.credentialsDomain = '';
        this.path = '';
        this.secure = true;
        const cookiesDefaultOptions = {
            credentialsDomain: typeof window === 'undefined' ? '' : window.location.hostname,
            expiresAt: 2 * 60 * 60 * 1000, // 2 hours
            secure: true,
            path: '',
            sameSite: 'Strict',
        };
        const params = (0, core_1.mergeDeepWithDefault)(cookiesDefaultOptions, cookiesStorageParams || {});
        if (params.expiresAt !== undefined) {
            this.expiresAt = params.expiresAt;
        }
        this.credentialsDomain = params.credentialsDomain;
        this.secure = params.secure;
        this.path = params.path;
        this.sameSite = params.sameSite;
    }
    /**
     * Gets the number of cookies stored.
     *
     * @returns The number of cookies.
     */
    get length() {
        return this.keys().length;
    }
    /**
     * Not implemented. Logs an error message.
     *
     * @param _index - The index of the key to retrieve.
     * @returns Always returns null.
     */
    key(_index) {
        core_1.Log.error('[cookieStorage.key] Method not implemented');
        return null;
    }
    /**
     * Retrieves all cookie names.
     *
     * @returns An array of all cookie names.
     */
    keys() {
        return cookies_1.CookieUtil.getAll();
    }
    /**
     * Sets a cookie with the given name and value.
     *
     * @param name - The name of the cookie.
     * @param value - The value of the cookie.
     */
    setItem(name, value) {
        this.checkLimit(value);
        const options = {
            credentialsDomain: this.credentialsDomain,
            expiresAt: this.expiresAt,
            path: this.path,
            sameSite: this.sameSite,
            secure: this.secure,
        };
        cookies_1.CookieUtil.set(name, value, options);
    }
    /**
     * Retrieves the value of the cookie with the given name.
     *
     * @param name - The name of the cookie to retrieve.
     * @returns The value of the cookie, or null if the cookie does not exist.
     */
    getItem(name) {
        return cookies_1.CookieUtil.get(name);
    }
    /**
     * Removes the cookie with the given name.
     *
     * @param name - The name of the cookie to remove.
     */
    removeItem(name) {
        const options = {
            credentialsDomain: this.credentialsDomain,
            expiresAt: this.expiresAt,
            path: this.path,
            sameSite: this.sameSite,
            secure: this.secure,
        };
        cookies_1.CookieUtil.remove(name, options);
    }
    /**
     * Removes all cookies from this domain and configuration.
     */
    clear() {
        core_1.Log.log('[cookieStorage.clear] Remove all cookies from this domain and config');
        this.keys().forEach(name => this.removeItem(name));
    }
    /**
     * Checks if the value exceeds the cookie size limit.
     *
     * @param value - The value to check.
     */
    checkLimit(value) {
        const size = new Blob([encodeURIComponent(value)]).size;
        if (size > 4000 /* 96 of margin of error */) {
            core_1.Log.warn(core_1.CoreHelperMessages.CORE_COOKIES_MAX_BYTES);
        }
    }
}
exports.CookieStorage = CookieStorage;
exports.cookieStorage = new CookieStorage();
//# sourceMappingURL=cookieStorage.js.map